import { render } from "./PreviewInvoice.vue?vue&type=template&id=48a84303&scoped=true"
import script from "./PreviewInvoice.vue?vue&type=script&lang=js"
export * from "./PreviewInvoice.vue?vue&type=script&lang=js"

import "./PreviewInvoice.vue?vue&type=style&index=0&id=48a84303&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a84303"]])

export default __exports__